const CustomerPage = () => {

    return (
        <div>
            <h1>Customer Page </h1>
        </div>
    )
}

export default CustomerPage;